var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.48072 12.2963L10.7347 20.0021C11.0773 20.3219 11.5295 20.5 12 20.5C12.4705 20.5 12.9227 20.3219 13.2653 20.0021L21.5192 12.2963C22.9079 11.0036 23.6935 9.19017 23.6935 7.29454V7.02961C23.6935 3.83673 21.3868 1.11433 18.2396 0.589031C16.1567 0.241879 14.0372 0.922479 12.5481 2.41158L12 2.95971L11.4518 2.41158C9.96275 0.922479 7.8433 0.241879 5.76039 0.589031C2.61319 1.11433 0.306458 3.83673 0.306458 7.02961V7.29454C0.306458 9.19017 1.09212 11.0036 2.48072 12.2963Z",
    fill: "#FF6B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIconOrange);
export default __webpack_public_path__ + "static/media/gift_icon_orange.a29faa0cac325cab8b9188ee1df4d031.svg";
export { ForwardRef as ReactComponent };